import React, { memo } from 'react';
import { AppNode } from '@/types';

interface DirectorContentProps {
  data: AppNode;
  onOpenDirector?: (nodeId: string) => void;
}

const DirectorContentComponent: React.FC<DirectorContentProps> = memo(({
  data,
  onOpenDirector,
}) => {
  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onOpenDirector?.(data.id);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full px-16 text-center">
      {/* 3D 堆叠方块图标 */}
      <div className="flex flex-col items-center text-white/40 mb-12">
        <svg width="96" height="96" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M24 4L40 12V28L24 36L8 28V12L24 4Z"
            fill="url(#director-grad-1)"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <path
            d="M24 14L36 20V30L24 36L12 30V20L24 14Z"
            fill="url(#director-grad-2)"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <path
            d="M24 24L32 28V34L24 38L16 34V28L24 24Z"
            fill="url(#director-grad-3)"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <defs>
            <linearGradient id="director-grad-1" x1="8" y1="4" x2="40" y2="36" gradientUnits="userSpaceOnUse">
              <stop stopColor="#52525b" stopOpacity="0.8" />
              <stop offset="1" stopColor="#27272a" stopOpacity="0.4" />
            </linearGradient>
            <linearGradient id="director-grad-2" x1="12" y1="14" x2="36" y2="36" gradientUnits="userSpaceOnUse">
              <stop stopColor="#52525b" stopOpacity="0.6" />
              <stop offset="1" stopColor="#27272a" stopOpacity="0.3" />
            </linearGradient>
            <linearGradient id="director-grad-3" x1="16" y1="24" x2="32" y2="38" gradientUnits="userSpaceOnUse">
              <stop stopColor="#52525b" stopOpacity="0.5" />
              <stop offset="1" stopColor="#27272a" stopOpacity="0.2" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* 描述文字 */}
      <h3 className="text-[36px] text-white/90 mb-16">
        在3D空间中搭建场景并进行多视角截图
      </h3>

      {/* 打开导演台按钮 */}
      <div className="flex flex-col gap-6 w-full max-w-[440px]">
        <button
          type="button"
          onClick={handleOpen}
          className="w-full h-24 rounded-3xl bg-white/[0.08] border-2 border-white/[0.15] text-[30px] text-white/90 hover:bg-white/[0.14] hover:border-white/[0.30] transition-all"
        >
          打开导演台
        </button>
      </div>
    </div>
  );
});

DirectorContentComponent.displayName = 'DirectorContent';
export const DirectorContent = DirectorContentComponent;
